
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import API from "./axiosInstance";
import "./Register.css";

function Register() {
  const navigate = useNavigate();

  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false); // Added state for password visibility

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
  });

  const [otp, setOtp] = useState("");

  /* =====================
     STEP 1 – SEND OTP
  ====================== */
  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await API.post("/auth/register", formData);
      alert("OTP sent to your email 📧");
      setStep(2);
    } catch (err) {
      alert(err.response?.data?.message || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  /* =====================
     STEP 2 – VERIFY OTP
  ====================== */
  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await API.post("/auth/verify-register-otp", {
        email: formData.email,
        otp,
      });

      alert("Registration successful ✅");
      navigate("/login");
    } catch (err) {
      alert(err.response?.data?.message || "Invalid OTP");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-page">
      <div className="register-card">
        <h2>{step === 1 ? "Create Account ✨" : "Verify OTP 🔐"}</h2>
        <p className="subtitle">
          {step === 1
            ? "Join KingShop & start shopping"
            : `OTP sent to ${formData.email}`}
        </p>

        {/* ===== STEP 1 ===== */}
        {step === 1 && (
          <form onSubmit={handleRegister}>
            <div className="input-group">
              <input
                type="text"
                placeholder="Full Name"
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
                required
              />
            </div>

            <div className="input-group">
              <input
                type="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
                required
              />
            </div>

            <div className="input-group" style={{ position: "relative" }}>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Create Password"
                value={formData.password}
                onChange={(e) =>
                  setFormData({ ...formData, password: e.target.value })
                }
                required
              />
              <span 
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  fontSize: "18px",
                  userSelect: "none"
                }}
              >
                {showPassword ? "🙈" : "👁"}
              </span>
            </div>

            <button type="submit" className="register-btn" disabled={loading}>
              {loading ? "Sending OTP..." : "Register"}
            </button>
          </form>
        )}

        {/* ===== STEP 2 ===== */}
        {step === 2 && (
          <form onSubmit={handleVerifyOtp}>
            <div className="otp-box">
              <input
                type="text"
                placeholder="Enter 6 digit OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                required
                maxLength="6"
              />
            </div>

            <button type="submit" className="register-btn" disabled={loading}>
              {loading ? "Verifying..." : "Verify OTP"}
            </button>

            <p className="resend" onClick={handleRegister}>
              Resend OTP
            </p>
          </form>
        )}

        <p className="login-link">
          Already have an account?
          <Link to="/login"> Login</Link>
        </p>
      </div>
    </div>
  );
}

export default Register;